"use client";

import { usePathname } from "next/navigation";
import HeroNavbar from "@/components/Navbar";

export const ClientLayout = ({ children }: { children: React.ReactNode }) => {
    const pathname = usePathname();
    const isLoginPage = pathname === "/";

    return (
        <div className="flex w-full h-full">
            {!isLoginPage && pathname !== "/exam" && <HeroNavbar />}
            <div className="flex-grow">
                {children}
            </div>
        </div>
    );
};